module.exports = __webpack_public_path__ + "img/1-sm.fc6f125e.jpg";